/**
 * 防抖函数，用于限制函数的执行频率
 * @param {Function} fn - 需要防抖的函数
 * @param {number} delay - 延迟时间（毫秒）
 * @param {boolean} immediate - 是否立即执行（第一次点击无延迟）
 * @returns {Function} - 防抖处理后的函数
 */
function debounce(fn, delay = 300, immediate = true) {
  let timer = null;
  let isFirstCall = true;
  
  return function(...args) {
    if (timer) {
      clearTimeout(timer);
    }
    
    if (immediate && isFirstCall) {
      // 第一次点击立即执行
      fn.apply(this, args);
      isFirstCall = false;
    } else {
      // 后续点击防抖
      timer = setTimeout(() => {
        fn.apply(this, args);
        timer = null;
      }, delay);
    }
  };
}

/**
 * 防抖点击hooks方法
 * @param {Function} fn - 点击事件处理函数
 * @param {number} delay - 延迟时间（毫秒）
 * @param {boolean} immediate - 是否立即执行（第一次点击无延迟）
 * @returns {Function} - 防抖处理后的点击事件处理函数
 */
export function useDebounceClick(fn, delay = 300, immediate = true) {
  return debounce(fn, delay, immediate);
}
